import { Button } from "./Button";

export interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
  className?: string;
  /** Fallback error text when `message` is not provided. */
  errorLabel?: string;
  /** Label for the retry button. */
  retryLabel?: string;
}

export function ErrorState({
  message,
  onRetry,
  className,
  errorLabel = "Something went wrong",
  retryLabel = "Retry",
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={`rounded-xl border border-[color:var(--error-200)] bg-[color:var(--error-50)] px-4 py-4 ${className ?? ""}`}
    >
      <p className="text-sm text-[color:var(--error-500)]">
        {message ?? errorLabel}
      </p>
      {onRetry ? (
        <div className="mt-3">
          <Button
            type="button"
            onClick={onRetry}
            variant="outline"
            size="sm"
          >
            {retryLabel}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
